module.exports = __webpack_public_path__ + "img/comparison.be1f0b63.png";